import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import PageHeaderTitle from "../../components/pages/PageHeaderTitle";
import DashboardHeader from "../../components/Other/DashboardHeader";
import { getGameFromSlug } from "../../api/user";
import { toast } from "react-toastify";
import LeaderboardSecton from "../../components/Other/LeaderboardSecton";
import FeedPage from "../FeedPage";
import CreatePostPage from "../CreatePostPage";


const GameCreatePost = (props) => {
  const [sidebarToggle] = useOutletContext();
    const { slug,postId } = useParams();
    const [loading, setLoading] = useState(false);
    const [game, setGame] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {

        const checkGameDates = (start_date, end_date) => {

            const endDate = new Date(end_date.replace(" ", "T")); // Parse game.end_date
            const startDate = new Date(start_date.replace(" ", "T")); // Parse game.start_date
            const today = new Date(); // Get today's date
            today.setHours(0, 0, 0, 0); // Set time to midnight to ignore time component

            if (today >= startDate && today <= endDate) {
                return true;
            } else {
                return false;
            }

        }

        const fetchGameId = async (slug) => {
            try {
                const response = await getGameFromSlug({ slug });
                const gameData = response?.data?.data;
                if (gameData) {
                    //if(checkGameDates(gameData.start_date, gameData.end_date)){
                        setGame(gameData);
                        setLoading(true);
                  //  }
                  //  else{
                      //  toast.error("League is not active");
                        // navigate("/contest/my-games");
                        // navigate("/contest/my-games", { state: { viewMode: "creator" } });
                  //  }
                } else {
                    //toast.error("League not found");
                    // navigate("/contest/my-games");
                  //  navigate("/contest/my-games", { state: { viewMode: "member" } });
                }
            } catch (error) {
                console.error("Error fetching game ID:", error);
            }
        };

        fetchGameId(slug);

    }, [slug]);

    return (
        <>
            {
                loading && (
                    <>
                        {/* Client Rev 2, global League Play rule 1: "Remove any screen title
                from under the QUSHi header logo." The league identity lives in
                LeagueShell now, so this second title was a duplicate.

                KEPT as a title-less PageHeaderTitle rather than deleted: this
                component is not only a title, it is also the spacer that clears
                the FIXED DashboardHeader (a desktop `h-16` block, and an `mt-16`
                wrapper on mobile). Deleting it outright slid the whole screen up
                under the header — the composer's avatar and "Posting to…" line
                were cut off, and Portfolio's tabs disappeared behind the logo.
                `showDesktopTitle={false}` drops the only visible title (the
                mobile one was already gated off) and keeps both offsets. */}
                <PageHeaderTitle showDesktopTitle={false} />
                        {/* <DashboardHeader toggle={sidebarToggle} /> */}
                        <CreatePostPage gameId={game?.id} slug={slug} postId={postId} game={game}/>

                    </>
                )
            }

        </>
    )
};

export default GameCreatePost;
